// extracted by mini-css-extract-plugin
export default {"noteWidgetRail":"NoteTakerShell_noteWidgetRail__i0X78","cancelCopy":"NoteTakerShell_cancelCopy__4pfaw"};